/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import I18n from 'I18n';
import { CONTENT } from 'ContentUtils/constants/CustomWidgetFieldGroupTabTypes';
import { FILE_UPLOAD_PRELOADED, FILE_UPLOAD_STARTED, FILE_UPLOAD_FAILURE, DRAG_LAYOUT_TILE, DRAG_ELEMENT_TILE, DRAG_ELEMENT, DRAG_SECTION, START_APP_DRAG, ENDED_APP_DRAG, DRAG_SAVED_SECTION } from 'EmailEditorUI/redux/actions/LayoutBuilderActionTypes';
import { SELECT_SECTION, SELECT_ELEMENT, ADD_NEW_COLUMN_AND_ELEMENT, ADD_NEW_COLUMN, REMOVE_COLUMN, DROP_ELEMENT_ON_SECTION, DROP_ELEMENT_ON_ELEMENT, DROP_ELEMENT_ON_PLACEHOLDER, DROP_SECTION_ON_SECTION, DROP_NEW_ELEMENT_ON_PLACEHOLDER, UPDATE_ELEMENT_DATA, UPDATE_SELECTED_SMART_RULE, REPOSITION_HUBSPOT_BRANDING_SECTION } from 'EmailEditorUI/redux/actions/IframeSyncedActionTypes';
import { SECTION, ELEMENT, ELEMENT_PLACEHOLDER } from 'LayoutBuilderUI/lib/DragDropConstants';
import { FULL_WIDTH_EXIT_MODAL } from 'EmailEditorUI/constants/InpageModals';
import { HUBSPOT_VIDEO_FIELD, PLAYER_ID_FIELD, VIDEO_TYPE_FIELD } from 'EmailEditorUI/constants/VideoConstants';
import { generateElementId } from 'EmailEditorUI/utils/dragDropModuleUtils';
import fileUploadUtils from 'LayoutBuilderUI/utils/fileUploadUtils';
import { getSections, getShouldShowHubspotBranding, sectionIsEmpty, getIsSectionBoxedHelper } from 'EmailEditorUI/redux/selectors/sectionSelectors';
import { getImageModuleSpec, getVideoModuleSpec, getElements } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { getHasHubspotVideoAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getResizeGraduationForSection, getMinColumnWidthForGraduationSizeHelper } from 'LayoutBuilderUI/selectors/resizeSelectors';
import { getLayoutSettings, getIsSingleColumnFullWidth } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { floatingAlertMessage, handleFileUpload, logInteraction } from 'LayoutBuilderUI/actions/ApiActions';
import { openInpageModal } from 'EmailEditorUI/redux/actions/inpageActions';
import { maybeAddWebVersionLinkModule, removeWebVersionLinkModule, createNewElementAction, dropNewElementOnElement, dropNewElementOnSection, updateMultipleElementFields } from 'EmailEditorUI/redux/actions/LayoutActions';
import { toggleBrandingPql } from 'EmailEditorUI/redux/actions/appActions';
import { getCollaborationSidebarState } from 'ContentEditorUI/redux/selectors/collaborationSidebarSelectors';

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export function selectSectionIfEmpty(index) {
  return (dispatch, getState) => {
    const isCommentModeActive = getCollaborationSidebarState(getState()).isCommentModeActive;
    if (sectionIsEmpty(getSections(getState()).get(index)) && !isCommentModeActive) {
      dispatch({
        type: SELECT_SECTION,
        index,
        selected: true
      });
    }
  };
}
export function selectHubspotBrandingSection() {
  return dispatch => dispatch(toggleBrandingPql(true));
}
export function repositionHubspotBrandingSection(isSingleColumnFullWidth) {
  return {
    type: REPOSITION_HUBSPOT_BRANDING_SECTION,
    payload: isSingleColumnFullWidth
  };
}
export const openFullWidthExitModal = modalProps => dispatch => {
  return dispatch(openInpageModal(FULL_WIDTH_EXIT_MODAL, modalProps));
};

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export function addNewColumn(sectionIndex, columnIndex, moduleData = {}) {
  return (dispatch, getState) => {
    const state = getState();
    const resizeGraduationSize = getResizeGraduationForSection(state, sectionIndex);
    const minWidth = getMinColumnWidthForGraduationSizeHelper(resizeGraduationSize);
    const baseAction = {
      index: sectionIndex,
      columnIndex,
      minWidth,
      dropPosition: moduleData.dropPosition
    };
    if (moduleData.moduleSpec) {
      dispatch(createNewElementAction(moduleData.moduleSpec, state, Object.assign({}, baseAction, {
        type: ADD_NEW_COLUMN_AND_ELEMENT
      })));
    } else {
      dispatch(Object.assign({}, baseAction, {
        type: ADD_NEW_COLUMN,
        elementId: moduleData.elementId || null
      }));
    }
  };
}
// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export function removeColumn(sectionIndex, columnIndex) {
  return dispatch => {
    dispatch({
      type: REMOVE_COLUMN,
      sectionIndex,
      columnIndex
    });
  };
}
// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export function selectElement(id, {
  selected = true,
  showErrorsImmediately = false,
  fieldPath = null,
  selectedByApp = false,
  tabId = CONTENT
} = {}) {
  return (dispatch, getState) => {
    const state = getState();
    const elements = getElements(state);
    if (!selected || elements.has(id)) {
      dispatch({
        type: SELECT_ELEMENT,
        id,
        selected,
        fieldPath,
        selectedByApp,
        showErrorsImmediately,
        tabId
      });
    }
  };
}
export function markElementAsSelected(id, options = {}) {
  const {
    fieldPath,
    tabId
  } = options;
  return selectElement(id, {
    showErrorsImmediately: true,
    fieldPath,
    selectedByApp: true,
    tabId
  });
}

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export function markElementAsSelectedWithSmartRule(id, criterionId) {
  return dispatch => {
    dispatch(selectElement(id, {
      selectedByApp: true,
      showErrorsImmediately: true
    }));
    setTimeout(() => {
      dispatch({
        type: UPDATE_SELECTED_SMART_RULE,
        id,
        smartRuleId: parseInt(criterionId, 10)
      });
    });
  };
}

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export function dropElementOnSection({
  elementId,
  dropPosition,
  targetSectionIndex,
  forceDropOutsideBoxed
}) {
  return (dispatch, getState) => {
    dispatch({
      type: DROP_ELEMENT_ON_SECTION,
      elementId,
      dropPosition,
      targetSectionIndex,
      forceDropOutsideBoxed,
      canMergeColumns: !getIsSingleColumnFullWidth(getState())
    });
  };
}

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export function dropElementOnElement({
  elementId,
  targetElementId,
  dropPosition
}) {
  return (dispatch, getState) => {
    dispatch({
      type: DROP_ELEMENT_ON_ELEMENT,
      elementId,
      targetElementId,
      dropPosition,
      canMergeColumns: !getIsSingleColumnFullWidth(getState())
    });
  };
}

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export function dropElementOnPlaceholder({
  elementId,
  placeholderSectionId,
  placeholderColumnId
}) {
  return (dispatch, getState) => {
    dispatch({
      type: DROP_ELEMENT_ON_PLACEHOLDER,
      elementId,
      placeholderSectionId,
      placeholderColumnId,
      canMergeColumns: !getIsSingleColumnFullWidth(getState())
    });
  };
}

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export function dropSectionOnSection({
  sectionId,
  dropPosition,
  targetSectionIndex,
  dropSectionIndex,
  forceDropOutsideBoxed
}) {
  return (dispatch, getState) => {
    const state = getState();
    const layoutSettings = getLayoutSettings(state);
    // only remove background styles when transitioning in/out of being boxed
    const targetIsBoxed = getIsSectionBoxedHelper(layoutSettings, targetSectionIndex);
    const droppedWasBoxed = getIsSectionBoxedHelper(layoutSettings, dropSectionIndex);
    const removeBackgroundStyles = layoutSettings.get('boxed') && (forceDropOutsideBoxed || targetIsBoxed && !droppedWasBoxed || droppedWasBoxed && !targetIsBoxed);
    const hasHubSpotBranding = getShouldShowHubspotBranding(state);
    dispatch({
      type: DROP_SECTION_ON_SECTION,
      sectionId,
      dropPosition,
      targetSectionIndex,
      dropSectionIndex,
      forceDropOutsideBoxed,
      removeBackgroundStyles,
      hasHubSpotBranding
    });
  };
}

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export function dropNewElementOnPlaceholder({
  moduleSpec,
  placeholderSectionId,
  placeholderColumnId,
  elementId = generateElementId()
}) {
  return (dispatch, getState) => {
    const state = getState();
    const isCommentModeActive = getCollaborationSidebarState(state).isCommentModeActive;
    dispatch(createNewElementAction(moduleSpec, state, {
      type: DROP_NEW_ELEMENT_ON_PLACEHOLDER,
      placeholderSectionId,
      elementId,
      placeholderColumnId,
      suppressSelection: isCommentModeActive
    }));
  };
}
export const uploadImageForModule = (moduleId, file) => dispatch => {
  logInteraction({
    action: 'Modify Layout Action',
    event: 'drag-drop-image-upload',
    'file-format': file ? file.type : null
  });
  let tempUrl = '';
  if (file.type && file.type.indexOf('image/') === 0) {
    tempUrl = window.URL.createObjectURL(file);
    fileUploadUtils.preloadImagePromise(tempUrl).then(meta => {
      dispatch(Object.assign({
        type: FILE_UPLOAD_PRELOADED,
        moduleId,
        file,
        tempUrl
      }, meta));
    });
  } else {
    floatingAlertMessage({
      type: 'danger',
      titleText: I18n.text('fileUpload.invalid.title'),
      message: I18n.text('fileUpload.invalid.imageMessage')
    });
    return;
  }
  dispatch({
    type: FILE_UPLOAD_STARTED,
    moduleId
  });
  handleFileUpload(file, moduleId, response => {
    const image = response.objects[0];
    if (image) {
      dispatch({
        type: UPDATE_ELEMENT_DATA,
        id: moduleId,
        elementData: {
          key: ['img'],
          value: {
            src: image.url,
            width: image.width,
            height: image.height,
            alt: image.alt
          }
        }
      });
    }
  }, () => {
    dispatch({
      type: FILE_UPLOAD_FAILURE,
      moduleId
    });
  });
};
export const uploadVideoForModule = (moduleId, file) => (dispatch, getState) => {
  if (!getHasHubspotVideoAccess(getState())) {
    floatingAlertMessage({
      type: 'danger',
      titleText: I18n.text('fileUpload.invalid.title'),
      message: I18n.text('fileUpload.invalid.imageMessage')
    });
    return;
  }
  if (!file.type || !file.type.startsWith('video')) {
    floatingAlertMessage({
      type: 'danger',
      titleText: I18n.text('fileUpload.invalid.title'),
      message: I18n.text('fileUpload.invalid.videoMessage')
    });
    return;
  }
  logInteraction({
    action: 'Modify Layout Action',
    event: 'drag-drop-video-upload',
    'file-format': file ? file.type : null
  });
  dispatch({
    type: FILE_UPLOAD_STARTED,
    moduleId
  });
  handleFileUpload(file, moduleId, response => {
    const video = response.objects[0];
    if (video) {
      // todo for dam-fe - this will stop working when we no longer reveal player_id here, move to fetching v2 video object here first
      const player_id = video.meta.video_data.hosting_infos[0].id;
      const data = {
        [VIDEO_TYPE_FIELD]: HUBSPOT_VIDEO_FIELD,
        [HUBSPOT_VIDEO_FIELD]: {
          [PLAYER_ID_FIELD]: player_id,
          height: video.height,
          width: video.width
        }
      };
      data[HUBSPOT_VIDEO_FIELD].player_type = 'hsvideo2';
      setTimeout(() => {
        dispatch(updateMultipleElementFields({
          id: moduleId,
          elementMultipleData: data
        }));
      }, 500);
    }
  }, () => {
    dispatch({
      type: FILE_UPLOAD_FAILURE,
      moduleId
    });
  });
};
export const dropNewImageElement = ({
  type,
  dropPosition,
  sectionIndex,
  elementId,
  file,
  sectionId,
  columnId
}) => (dispatch, getState) => {
  const moduleSpec = getImageModuleSpec(getState());
  const newElementId = generateElementId();
  const baseObject = {
    moduleSpec,
    elementId: newElementId,
    dropPosition
  };
  if (type === SECTION) {
    dispatch(dropNewElementOnSection(Object.assign({}, baseObject, {
      targetSectionIndex: sectionIndex
    })));
  } else if (type === ELEMENT) {
    dispatch(dropNewElementOnElement(Object.assign({}, baseObject, {
      targetElementId: elementId
    })));
  } else if (type === ELEMENT_PLACEHOLDER) {
    dispatch(dropNewElementOnPlaceholder(Object.assign({}, baseObject, {
      placeholderSectionId: sectionId,
      placeholderColumnId: columnId
    })));
  }
  dispatch(uploadImageForModule(newElementId, file));
};
export const dropNewVideoElement = ({
  type,
  dropPosition,
  sectionIndex,
  elementId,
  file,
  sectionId,
  columnId
}) => (dispatch, getState) => {
  const moduleSpec = getVideoModuleSpec(getState());
  const newElementId = generateElementId();
  const baseObject = {
    moduleSpec,
    elementId: newElementId,
    dropPosition
  };
  if (type === SECTION) {
    dispatch(dropNewElementOnSection(Object.assign({}, baseObject, {
      targetSectionIndex: sectionIndex
    })));
  } else if (type === ELEMENT) {
    dispatch(dropNewElementOnElement(Object.assign({}, baseObject, {
      targetElementId: elementId
    })));
  } else if (type === ELEMENT_PLACEHOLDER) {
    dispatch(dropNewElementOnPlaceholder(Object.assign({}, baseObject, {
      placeholderSectionId: sectionId,
      placeholderColumnId: columnId
    })));
  }
  dispatch(uploadVideoForModule(newElementId, file));
};
export const dropNewImageElements = ({
  type,
  dropPosition,
  sectionIndex,
  elementId,
  files,
  sectionId,
  columnId
}) => dispatch => {
  files.forEach(file => {
    dispatch(dropNewImageElement({
      type,
      dropPosition,
      sectionIndex,
      elementId,
      file,
      sectionId,
      columnId
    }));
  });
};
export const dropNewVideoElements = ({
  type,
  dropPosition,
  sectionIndex,
  elementId,
  files,
  sectionId,
  columnId
}) => dispatch => {
  files.forEach(file => {
    dispatch(dropNewVideoElement({
      type,
      dropPosition,
      sectionIndex,
      elementId,
      file,
      sectionId,
      columnId
    }));
  });
};
export function mirrorWebVersionChange(createPage) {
  return dispatch => {
    if (createPage) {
      dispatch(maybeAddWebVersionLinkModule());
    } else {
      dispatch(removeWebVersionLinkModule());
    }
  };
}
export function dragLayoutTile() {
  return {
    type: DRAG_LAYOUT_TILE
  };
}
export function dragElementTile() {
  return {
    type: DRAG_ELEMENT_TILE
  };
}
export function dragElement() {
  return {
    type: DRAG_ELEMENT
  };
}
export function dragSection() {
  return {
    type: DRAG_SECTION
  };
}
export function dragSavedSection() {
  return {
    type: DRAG_SAVED_SECTION
  };
}
export function startAppDrag(draggedItemType) {
  return {
    type: START_APP_DRAG,
    draggedItemType
  };
}
export function endedAppDrag() {
  return {
    type: ENDED_APP_DRAG
  };
}